export const GET_MAINTENANCE_PACKAGE = 'GET_MAINTENANCE_PACKAGE';
export const GET_MAINTENANCE_PACKAGES = 'GET_MAINTENANCE_PACKAGES';
export const CREATE_MAINTENANCE_PACKAGE = 'CREATE_MAINTENANCE_PACKAGE';
export const DELETE_MAINTENANCE_PACKAGE = 'DELETE_MAINTENANCE_PACKAGE';
export const UPDATE_MAINTENANCE_PACKAGE = 'UPDATE_MAINTENANCE_PACKAGE';
